<template>
  <div class="bg-white h-100">
    <div class="d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
      <i class="mdi" :class="icon" style="font-size: 1.5rem"></i>
      <h4 class="text-center m-0">{{ title }}</h4>
      <span class="clickable" @click="$emit('close')">
        <i class="mdi mdi-close" style="font-size: 1.5rem"></i>
      </span>
    </div>
    <b-list-group flush v-if="documentRecipients">
      <b-list-group-item
        v-for="recipient in documentRecipients"
        :key="recipient.id"
      >
        <i
          style="font-size: 20px"
          class="mr-2 mdi"
          :class="`mdi-${recipient.icon}`"
        />
        <span class="flex-grow-1">
          {{ recipient.name }}
        </span>
      </b-list-group-item>
    </b-list-group>
    <LmSvgIcon
      v-else
      wrapperClass="d-flex mt-5 justify-content-center align-items-center flex-column"
      width="6em"
      icon="LmNoDataIcon"
      text="Este documento no posee destinatarios."
    />
  </div>
</template>

<script>
export default {
  props: {
    recipients: {
      type: Object,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    documentRecipients () {
      let recipients = []
      for (const key in this.recipients) {
        recipients = recipients.concat(this.recipients[key].map(r => {
          return {
            ...r,
            icon: this.setIcon(key)
          }
        }))
      }
      return recipients.length ? recipients : null
    }
  },
  methods: {
    setIcon (type) {
      const icons = {
        users: 'account',
        areas: 'domain',
        subareas: 'account-group',
        mesas: 'account-multiple',
        emails: 'at'
      }
      return icons[type]
    }
  }
}
</script>
